export default class TravelServiceOrderItem {
  sequence = 0;
  related_sequence = null;
  travelServiceOrderItemCar = null;
  travelServiceOrderItemFlight = null;
  travelServiceOrderItemHotel = null;
  travelServiceOrderItemRail = null;
  travelServiceOrderItemInsurance = null;
  travelServiceOrderItemResponseOptions = [];
  //  travel_service_order_item_selected_response_id = null;
  //  travel_service_order_item_selected_return_response_id = null;

  id = null;
  travel_service_order_id = null;
  status = 1;
  params = null;
  type = null;
  comment = null;
  cost_centre = null;
  travelServiceOrderItemPassengers = [];
  related_travel_service_order_item_guid = null;
  group_id = null;
}
